import { atom } from 'recoil';
import { sessionStorageEffect } from 'services/storage/sessionStorage';

enum StateKey {
  UserAuthState = 'UserAuthState',
  UserDataErrorState = 'UserDataErrorState'
}

export type UserAuth = {
  username: string;
  attributes: {
    email: string;
    sub: string;
  };
} | null;

// `undefined` denotes a pending session check; route guards must wait for it.
export const userAuthAtom = atom<UserAuth | undefined>({
  key: StateKey.UserAuthState,
  default: undefined,
  effects: [sessionStorageEffect(StateKey.UserAuthState)]
});

// True when the session is valid but its user data did not load. The route
// guards need that data, so they offer a retry instead of waiting for ever.
export const userDataErrorAtom = atom<boolean>({
  key: StateKey.UserDataErrorState,
  default: false
});
